export const REGION_PERMISSIONS = {
  VIEW: 'rc_view_region_management',
} as const;

export type RegionPermissions = typeof REGION_PERMISSIONS[keyof typeof REGION_PERMISSIONS];
